import React from "react";

interface Admin {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  created_at?: string;
  updated_at?: string;
}

interface AdminTableProps {
  data: Admin[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemsPerPage: number;
}

const AdminTable: React.FC<AdminTableProps> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
}) => {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = data.slice(startIndex, endIndex);

  return (
    <div className="p-4 sm:p-6 bg-white rounded-lg shadow-md w-full">
      {/* Horizontal scroll wrapper for small screens */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-[600px] sm:min-w-full table-auto border border-gray-300 text-sm">
          <thead>
            <tr>
              {["ID", "First Name", "Last Name", "Email", "Phone"].map(
                (header) => (
                  <th
                    key={header}
                    className="px-3 py-2 bg-amber-200 text-left text-xs font-semibold text-black uppercase tracking-wider whitespace-nowrap"
                  >
                    {header}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((admin) => (
                <tr key={admin._id} className="hover:bg-gray-50">
                  <td className="px-3 py-3 border-b text-left break-all max-w-[200px] whitespace-nowrap">
                    {admin._id}
                  </td>
                  <td className="px-3 py-3 border-b text-left">
                    {admin.first_name}
                  </td>
                  <td className="px-3 py-3 border-b text-left">
                    {admin.last_name}
                  </td>
                  <td className="px-3 py-3 border-b text-left break-words max-w-[200px]">
                    {admin.email}
                  </td>
                  <td className="px-3 py-3 border-b text-left">
                    {admin.phone}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center py-4 text-gray-500">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination controls */}
      <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="h-10 px-5 rounded-md border border-amber-500 text-black disabled:opacity-50 w-full sm:w-auto"
        >
          Previous
        </button>
        <span className="text-sm text-gray-700 text-center">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="h-10 px-5 rounded-md border border-amber-500 text-black disabled:opacity-50 w-full sm:w-auto"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdminTable;
